// extracted by mini-css-extract-plugin
export default {"continer":"Footer_continer__BnJME"};